import React, { useMemo, useState } from "react";
import ReactDOM from "react-dom";
import { CssBaseline, ThemeProvider } from "@mui/material";
import App from "./App";
import "./index.scss";
import { buildTheme } from "./ui/theme";
import ColorModeContext from "./context/ColorModeContext";

const Root = () => {
  const [mode, setMode] = useState("light");

  const theme = useMemo(() => buildTheme(mode), [mode]);
  const toggleColorMode = () => {
    setMode((prevMode) => (prevMode === "light" ? "dark" : "light"));
  };

  return (
    <ColorModeContext.Provider value={{ mode, toggleColorMode }}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <App mode={mode} toggleColorMode={toggleColorMode} />
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
};

ReactDOM.render(<Root />, document.getElementById("root"));
